import { Attachment, Checkbox, DataSource, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlConfigurations extends Layout {
    attachmentConfigFile: Attachment;
    checkboxMakeDefault: Checkbox;
    labelConfigurationFiles: Label;
    panelConfigurationsContent: Panel;
    panelProcessSettings: Panel;
    sourceMCControl: DataSource;
    sourceMCScheduledConfig: DataSource;
    switchEnableProcess: Switch;
    tableScheduledConfig: Table;
    textboxConfigFile: Textbox;
    textboxExecutionType: Textbox;
    textboxInitialDelayMins: Textbox;
    textboxMonitorMode: Textbox;
    textboxProcessName: Textbox;
    textboxRunFrequency: Textbox;
    textboxStopMethod: Textbox;
}
